var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInstagram = function SvgInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0228 0H9.97723C4.46696 0 0 4.46827 0 9.98017V10.0257C0 15.5376 4.46696 20.0059 9.97723 20.0059H10.0228C15.533 20.0059 20 15.5376 20 10.0257V9.98017C20 4.46827 15.533 0 10.0228 0Z",
    fill: "url(#paint0_linear_52_5095)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0958 4.07068H6.90723C5.19752 4.07068 3.80664 5.46197 3.80664 7.17218V12.8355C3.80664 14.5457 5.19752 15.937 6.90723 15.937H13.0958C14.8055 15.937 16.1964 14.5457 16.1964 12.8355V7.17218C16.1964 5.46197 14.8055 4.07068 13.0958 4.07068ZM4.90043 7.17218C4.90043 6.06545 5.80082 5.16479 6.90723 5.16479H13.0958C14.2022 5.16479 15.1026 6.06545 15.1026 7.17218V12.8355C15.1026 13.9422 14.2022 14.8429 13.0958 14.8429H6.90723C5.80082 14.8429 4.90043 13.9422 4.90043 12.8355V7.17218Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0013 12.8875C11.5911 12.8875 12.8853 11.5936 12.8853 10.0025C12.8853 8.41148 11.5918 7.11761 10.0013 7.11761C8.41068 7.11761 7.11719 8.41148 7.11719 10.0025C7.11719 11.5936 8.41068 12.8875 10.0013 12.8875ZM10.0013 8.21243C10.9885 8.21243 11.7915 9.01566 11.7915 10.0032C11.7915 10.9908 10.9885 11.794 10.0013 11.794C9.01398 11.794 8.21098 10.9908 8.21098 10.0032C8.21098 9.01566 9.01398 8.21243 10.0013 8.21243Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1521 7.58433C13.5802 7.58433 13.9291 7.23598 13.9291 6.80703C13.9291 6.37807 13.5809 6.02972 13.1521 6.02972C12.7232 6.02972 12.375 6.37807 12.375 6.80703C12.375 7.23598 12.7232 7.58433 13.1521 7.58433Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_52_5095",
    x1: 2.92191,
    y1: 17.0831,
    x2: 17.0823,
    y2: 2.92764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAAD4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#DD2A7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#9537B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515BD4"
  })))));
};
export default SvgInstagram;